<script setup>
import { computed, ref } from "vue";
import { useBranchesStore } from "@/stores/branches";
import { storeToRefs } from "pinia";

const branchesStore = useBranchesStore();
const { setSelectedBranch } = branchesStore;
const { branches, selectedBranchData } = storeToRefs(useBranchesStore());

const loading = ref(false);

// eslint-disable-next-line no-undef
const emit = defineEmits(["changedBranch"]);

const selectBranch = (id) => {
  setSelectedBranch(id);
  emit("changedBranch", id);
};
const fullAddressBranch = computed(
  () =>
    `${selectedBranchData.value?.street}, ${selectedBranchData.value?.zip} ${selectedBranchData.value?.city},${selectedBranchData.value?.country}`,
);
</script>

<template>
<div class="branches">
  <h5>
    {{ $t('branches.our_branches') }}
    <i class="fa-angle-right fas button-icon-right" aria-hidden="true"></i>
  </h5>
  <div v-if="loading" class="loader-container">
    <div class="loader"></div>
  </div>
  <ul v-else class="branch-list">
    <li
      v-for="branch in branches"
      :key="branch.id"
      @click="selectBranch(branch.id)"
      :class="{ active: selectedBranchData?.id === branch.id }"
    >
      <img :src="branch?.image_url" :alt="branch.title" />
      {{ branch.title }}
    </li>
  </ul>
</div>
<div v-if="selectedBranchData" class="center-image">
  <div class="image-headline">
    <h2>{{ selectedBranchData.title }}</h2>
    {{ fullAddressBranch }}
  </div>
  <img :src="selectedBranchData?.image_url" :alt="selectedBranchData.title" />
</div>
</template>

<style scoped lang="scss">
.branches {
  flex-basis: 20%;
  margin-right: 35px;
  border-radius: 10px;
  min-width: 20%;
}
.branches h5 {
  font-size: 1.4em;
  margin-bottom: 10px;
  color: #c39700;
  text-align: left;
  text-transform: uppercase;
  margin-top: 0.65em;
}
.branches h5 i {
  font-size: 1.1em;
  transform: rotateZ(90deg);
}
.branches .branch-list {
  list-style: none;
  background: #fff;
  padding-left: 0;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  overflow: hidden;
}
.branches .branch-list li {
  padding: 15px;
  cursor: pointer;
  transition: background 0.3s;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.2rem;
  text-align: left;
  border-bottom: 1px solid #f3f3f3;
}
.branches .branch-list li.active {
  background: #c39700;
  color: white;
  font-weight: bold;
}
.branches .branch-list li img {
  margin-right: 20px;
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}
.center-image {
  flex-basis: 30%;
  margin-top: 18px;
  margin-bottom: 10px;
  margin-right: 35px;
  max-width: 30%;
  overflow: hidden;
  img {
    height: 320px;
    width: 100%;
    object-fit: cover;
  }
}
.image-headline {
  color: #c39700;
  margin-bottom: 20px;
  text-align: left;
  font-size: 20px;
  h2 {
    color: inherit;
    display: block;
    font-size: 1.3em;
  }
}
@media screen and (max-width: 1600px) {
}
@media screen and (max-width: 1400px) {
  .branches {
    flex-basis: 50%;
  }
  .center-image {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .branches {
    flex-basis: 35%;
  }
}
@media screen and (max-width: 1000px) {
  .center-image {
    display: none;
  }
  .branches {
    min-width: 100%;
  }
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
